import {AxiosInstance} from "axios";
import {ongBaseApi} from "./ong-base-api";
import {OngBaseResponse} from "./ong-base-response";
import {CoordinateListDto} from "../types/coordinates/worker-coordinate-dto";

export enum CoordinateApiUrl {
    getAll = "/redis/coordinates",
}

class CoordinateApi {
    private _api: AxiosInstance;

    constructor(api: AxiosInstance) {
        this._api = api;
    }

    async getAll(): Promise<OngBaseResponse<CoordinateListDto>> {
        return await this._api.get(CoordinateApiUrl.getAll);
    }
}

export const coordinateApi = new CoordinateApi(ongBaseApi);
